import type { TaskDto, TaskScope } from '@bk/contracts';
import { useEffect, useState } from 'react';
import { errorMessage } from '../../lib/api';
import { navigate } from '../../lib/router';
import { useTenant, useTenantQuery } from '../../lib/useTenant';
import { Button, Empty, ErrorText, PageTitle } from '../../ui';
import { useSetupProgress } from './Setup';
import { TaskCard } from './TaskCard';

/**
 * "Oggi": i miei task; per i responsabili anche tutti quelli aperti e quelli da assegnare. Entrando nell'azienda con
 * la configurazione guidata non ancora finita si riparte da lì, dal passo raggiunto.
 */
export function Today({ entry = false }: { entry?: boolean }) {
  const { isManager, tenant } = useTenant();
  const progress = useSetupProgress(isManager);
  const g = progress.data?.guidata;
  const resume = entry && !!g && !g.finita;
  useEffect(() => {
    if (resume) window.location.replace(`#/t/${tenant.id}/configurazione`);
  }, [resume, tenant.id]);
  const [scope, setScope] = useState<TaskScope>(isManager ? 'open' : 'mine');
  const tasks = useTenantQuery<{ data: TaskDto[] }>(['tasks', scope], `/tasks?scope=${scope}`, { refetchInterval: 15_000 });
  const tab = (id: TaskScope, label: string) => (
    <Button variant="ghost" className={scope === id ? 'bg-black/5 text-ink' : ''} onClick={() => setScope(id)}>
      {label}
    </Button>
  );
  return (
    <>
      {isManager && progress.data?.prossimo && (
        <div className="mb-5 flex flex-wrap items-center gap-3 rounded-xl border border-accent/30 bg-accent/5 px-4 py-3 text-sm">
          <p className="min-w-0 flex-1">
            <span className="font-medium">Configurazione al {progress.data.percentuale}%.</span>{' '}
            {progress.data.prossimo.testo}
          </p>
          <Button variant="ghost" onClick={() => navigate(`/t/${tenant.id}/configurazione`)}>
            Percorso
          </Button>
          <Button onClick={() => navigate(`/t/${tenant.id}/${progress.data!.prossimo!.link}`)}>Vai</Button>
        </div>
      )}
      <PageTitle
        title="Oggi"
        subtitle="Le cose da fare, chiuse a mano da chi le esegue o dal responsabile per suo conto."
        actions={
          <div className="flex gap-1">
            {tab('mine', 'I miei task')}
            {isManager && tab('open', 'Tutti gli aperti')}
            {isManager && tab('unassigned', 'Da assegnare')}
          </div>
        }
      />
      <ErrorText>{tasks.error ? errorMessage(tasks.error) : ''}</ErrorText>
      {tasks.data?.data.length === 0 && (
        <Empty>{scope === 'mine' ? 'Nessun task assegnato a te. Collega il tuo account a una persona in "Persone" per vedere i tuoi.' : 'Nessun task aperto.'}</Empty>
      )}
      <div className="grid gap-3 md:grid-cols-2">
        {tasks.data?.data.map((task) => <TaskCard key={task.id} task={task} />)}
      </div>
    </>
  );
}
